import React, { FC, ReactElement } from 'react';

import { Breakpoint, Dialog } from '@mui/material';

import styles from './DialogWrapper.module.scss';

type Props = {
  children: ReactElement;
  open: boolean;
  onClose: () => void;
  fullWidth?: boolean;
  maxWidth?: Breakpoint;
  compact?: boolean;
};

const DialogWrapper: FC<Props> = ({ children, onClose, open, fullWidth = true, maxWidth = 'lg', compact = false }) => {
  const handleClose = () => {
    onClose();
  };

  const paperProps = compact
    ? {
        sx: {
          width: '560px',
          maxWidth: 'calc(100% - 32px)',
          borderRadius: '16px',
          '@media (max-width: 992px)': {
            margin: '16px',
            width: 'calc(100% - 32px)',
            maxWidth: 'calc(100% - 32px)',
          },
        },
      }
    : undefined;

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      className={styles.dialog}
      PaperProps={paperProps}
    >
      {children}
    </Dialog>
  );
};

export default DialogWrapper;
